<section class="survey-audit-page" *ngIf="config" [ngStyle]="config.styleVars">
  <header class="page-card title-card">
    <div>
      <h1>{{ config.dashboardName }}</h1>
      <p *ngIf="config.subtitle">{{ config.subtitle }}</p>
    </div>
  </header>

  <nav class="mode-tabs" aria-label="Survey audit modes">
    <button
      type="button"
      *ngFor="let tab of visibleTabs; trackBy: trackByProp"
      [class.active]="mode === tab.key"
      (click)="setMode(tab.key, tab)"
    >
      {{ tab.label }}
    </button>
  </nav>

  <section class="page-card filter-card" *ngIf="showRollupFilterBar">
    <div class="material-scope" *ngFor="let filter of rollupFilters; trackBy: trackByProp" [class.search-field]="filter.type === 'search'">
      <span class="rollup-filter-label" *ngIf="filter.type === 'select'">{{ filter.label }}</span>
      <mat-form-field *ngIf="filter.type === 'select'">
        <mat-select
          [(ngModel)]="fieldState[filter.model]"
          panelClass="survey-rollup-select-panel"
          (selectionChange)="onRollupFilterChange(filter)"
        >
          <mat-option *ngIf="filter.enableSearch">
            <ngx-mat-select-search
              [placeholderLabel]="filter.searchPlaceholder"
              [noEntriesFoundLabel]="filter.noEntriesFoundLabel"
              ngModel
              (ngModelChange)="filterRollupSelection(filter, $any($event))"
            ></ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let option of filter.filteredOptions || filter.options" [value]="option">
            {{ option }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <input
        *ngIf="filter.type === 'search'"
        [(ngModel)]="fieldState[filter.model]"
        type="search"
        [placeholder]="filter.placeholder"
      />
    </div>
    <div class="inline-legend" *ngIf="mode === 'entry'">
      <div class="legend-item" *ngFor="let item of config.entry.legendItems; trackBy: trackByProp">
        <strong>{{ item.key }}</strong>
        <span>{{ item.text }}</span>
      </div>
    </div>
    <button type="button" class="export-btn" *ngIf="showRollupFilterExport">
      <span class="material-icons">{{ config.exportButton?.icon }}</span>
      {{ config.exportButton?.label }}
    </button>
  </section>

  <ng-container *ngIf="mode === 'entry'; else rollupView">
    <app-audit-data
      [data]="config.entry.auditData"
      [initialFilters]="entryInitialFilters"
    ></app-audit-data>
  </ng-container>

  <ng-template #rollupView>
    <app-survey-pm-rollup
      [config]="config.rollup"
      [icons]="config.icons"
      [scoreConfig]="config.scoreConfig"
      (viewAllResponses)="openEntryResponses($event)"
      (refreshRollup)="refreshRollupSummary()"
    ></app-survey-pm-rollup>
  </ng-template>
</section>
